// Components==============
import storeWrongAnswer from 'actions/wrongAnswer/store';
import ArrowButton from 'components/UI/ArrowButton/ArrowButton';
import Column from 'components/UI/ExerciseColumn/Column';
import { motion } from 'framer-motion';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { HomeworkContext } from 'screens/Homework/Homework';
import { shake } from 'utilities/framerAnimations';
import { MultipleChoiceExerciseContext } from '../../MultipleChoiceExercise';
import './Category.module.scss';
// =========================

export default function Category({ category }: { category: Categories }) {
    const { answer, setUserAnswers, current, userAnswers } = useContext(
        MultipleChoiceExerciseContext
    );

    const { sequence, background } = useContext(HomeworkContext);

    const [triggerAnimation, setTriggerAnimation] = useState(false);
    const [answerIsCorrect, setAnswerIsCorrect] = useState(false);

    const dispatch = useDispatch();

    const { treatmentId, homeworkId } = useParams() as {
        treatmentId: string;
        homeworkId: string;
    };

    useEffect(() => {
        setTimeout(() => {
            setTriggerAnimation(false);
        }, 1000);
    }, [triggerAnimation]);

    useEffect(() => {
        if (current === userAnswers.length) return setAnswerIsCorrect(false);

        if (userAnswers[current].answer === category.name)
            setAnswerIsCorrect(true);
        else setAnswerIsCorrect(false);
    }, [current]);

    const inCategory =
        category.words.find((w) => answer?.id === w?.id) !== undefined;

    function storeWrong() {
        dispatch(
            storeWrongAnswer({
                given_answer: category.name,
                correct_answer: answer.name,
                metadata: {
                    sequence,
                },
                type: 'woord',
                exercise_id: homeworkId,
                exercise_type: 'homework',
                treatment_id: treatmentId,
            })
        );
    }

    function handleClick() {
        if (answerIsCorrect) return;

        if (inCategory) {
            setUserAnswers((prev) => [
                ...prev,
                { answer: category.name, word: answer.name },
            ]);
            setAnswerIsCorrect(true);
        }

        if (!inCategory) {
            setTriggerAnimation(true);
            storeWrong();
        }
    }

    const isAnswered = userAnswers[current] !== undefined;

    return (
        <motion.div
            styleName="wrapper"
            animate={triggerAnimation ? { x: shake } : { x: 0 }}
            initial={{ x: 0 }}
        >
            <Column
                disablePadding
                useWords={1}
                useImages={1}
                name={category?.name}
                image={category?.image}
                showSpeaker={1}
                isSound={category?.is_sound}
                background={background}
                disableOverflow
            >
                <ArrowButton
                    handleClick={handleClick}
                    answerIsCorrect={answerIsCorrect}
                    isAnswered={isAnswered}
                    background={background}
                />
            </Column>
        </motion.div>
    );
}
